import { connect } from 'react-redux'
import GroupBrowse from './GroupBrowse.jsx'
import {
    nextGroup,
    previousGroup,
} from '../../../redux/navigation/actions'
import {
    getGroupPosition,
    getGroupsCount,
    isPrevGroupNavEnabled,
    isNextGroupNavEnabled,
} from '../../../redux/navigation/selectors'

const mapStateToProps = state => ({
    currentPosition: Number(getGroupPosition(state)),
    count: getGroupsCount(state),
    hasPrevious: isPrevGroupNavEnabled(state),
    hasNext: isNextGroupNavEnabled(state),
})

const mapDispatchToProps = dispatch => ({
    onPrevious: () => dispatch(previousGroup()),
    onNext: () => dispatch(nextGroup()),
})

export const GroupBrowseContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(GroupBrowse)
